var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentOptionsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00064 3.66671C2.91756 3.66671 3.66778 2.91671 3.66778 2.00004C3.66778 1.08337 2.91756 0.333374 2.00064 0.333374C1.08371 0.333374 0.333496 1.08337 0.333496 2.00004C0.333496 2.91671 1.08371 3.66671 2.00064 3.66671ZM2.00064 5.33337C1.08371 5.33337 0.333496 6.08337 0.333496 7.00004C0.333496 7.91671 1.08371 8.66671 2.00064 8.66671C2.91756 8.66671 3.66778 7.91671 3.66778 7.00004C3.66778 6.08337 2.91756 5.33337 2.00064 5.33337ZM2.00064 10.3334C1.08371 10.3334 0.333496 11.0834 0.333496 12C0.333496 12.9167 1.08371 13.6667 2.00064 13.6667C2.91756 13.6667 3.66778 12.9167 3.66778 12C3.66778 11.0834 2.91756 10.3334 2.00064 10.3334Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOptionsIcon);
export default __webpack_public_path__ + "static/media/document_options_icon.1c609bd8333e2db8126d21b004cde103.svg";
export { ForwardRef as ReactComponent };